/* eslint no-param-reassign: 0 */
import Axios from 'axios';
import LocalStorage from '../utils/localStorage'; // TODO: Esse adapter está dependendo de outro por causa do login

export default class Http {
  constructor(urlBase) {
    this.axios = Axios.create({ baseURL: urlBase });

    this.axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
    this.axios.interceptors.response.use((response => response), (error) => {
      if (error.response.status === 401) {
        LocalStorage.remover('usuario', 'permissoes', 'protocolo');
        window.location.hash = '#/login-seguranca';
      }

      return Promise.reject(error);
    });
  }

  setarTokenDeAutenticacao(token) {
    this.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  limparTokenDeAutenticacao() {
    this.axios.defaults.headers.common.Authorization = null;
  }

  get(path, params = {}, headers = {}) {
    return this.axios.get(path, { params, headers });
  }

  getArraybuffer(path) {
    return this.axios.get(path, { responseType: 'arraybuffer' });
  }

  post(path, body = {}, headers = {}) {
    return this.axios.post(path, body, { headers });
  }

  put(path, body = {}, headers = {}) {
    return this.axios.put(path, body, { headers });
  }

  delete(path, body = {}, headers = {}) {
    return this.axios.delete(path, body, { headers });
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js